import { Container, Link as MuiLink, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import PageTitle from '../components/coreLayout/PageTitle';
import Seo from '../components/coreLayout/Seo';
import ProductDisplayGrid from '../components/features/ProductDisplayGrid';
import { ProductCategories } from '../utils/models/products';

export const categorySx = {
    containerPadding: {
        paddingLeft: { xs: '10px', sm: '24px' },
        paddingRight: { xs: '10px', sm: '24px' },
    },
    title: {
        fontSize: { xs: 30, sm: 38 },
        color: 'primary.main',
        lineHeight: '115%',
        letterSpacing: '-1px',
        fontWeight: 400,
        paddingBottom: '15px',
        marginTop: { xs: '40px', sm: 0 },
        textAlign: 'center',
    },
    body: {
        fontSize: { xs: 16, sm: 18 },
        opacity: 0.8,
        fontWeight: 400,
        paddingBottom: '15px',
        maxWidth: { xs: '90%', sm: '75%' },
        textAlign: 'center',
    },
} as const;

export default function CairnsTours() {
    return (
        <>
            <Seo
                title="Cairns Tours & Great Barrier Reef Scenic Flights | GSL Aviation"
                description="Explore Cairns and the Great Barrier Reef with GSL Aviation. Daily scenic flights, reef day trips and package tours over Green Island and the Great Barrier Reef."
                path="/cairns"
            />
            <Container maxWidth="lg" sx={categorySx.containerPadding}>
                <PageTitle
                    title="Cairns Tours"
                    tagline="Daily departures from Cairns Airport. See the Great Barrier Reef &amp; Green Island from above"
                />
            </Container>
            <Container
                maxWidth="lg"
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '5%' }}
            >
                <Typography variant="h4" sx={categorySx.title}>
                    Fly above it all
                </Typography>
                <Typography sx={categorySx.body}>
                    Explore our range of scenic flights, packages, and extended tours. Our range of products offer a
                    great variety of experiences, in the beautiful North Qld tropics.
                </Typography>
                <Typography sx={categorySx.body}>
                    Weighing up a helicopter tour?{' '}
                    <MuiLink
                        component={Link}
                        to="/cairns/helicopter-tours"
                        underline="hover"
                        sx={{ color: 'primary.main' }}
                    >
                        See our helicopter vs scenic flight comparison
                    </MuiLink>
                    .
                </Typography>
            </Container>
            <ProductDisplayGrid category={ProductCategories.CAIRNS} />
            <div style={{ marginBottom: 40, width: '100%' }} />
        </>
    );
}
